// Hero-title animation

var hotbod = document.querySelector("body");
function doStuff() {
    hotbod.className += " animate";
}
window.onload = function() {
    doStuff();
};

